import { AxiosPromise } from 'axios';
import { EndPointService } from 'src/services/api-handlers/axios';

function getDistricts(params: any): AxiosPromise {
    return EndPointService.get('/districts', { params });
}

function getDistrictsSmall(params: any): AxiosPromise {
    return EndPointService.get('/district-simply-list', { params });
}

function getDistrict(id: number | string): AxiosPromise {
    return EndPointService.get(`/districts/${id}`);
}

function deleteDistrict(id: number | string): AxiosPromise {
    return EndPointService.delete(`/districts/${id}`);
}

function createDistrict(payload: any): AxiosPromise {
    return EndPointService.post('/districts', payload);
}

function deleteFileDistrict(fileId: number | string): AxiosPromise {
    return EndPointService.delete(`/district_docs/${fileId}`);
}

function createFilesDistrict(data: any): AxiosPromise {
    return EndPointService.post(`/district_docs`, data);
}

function getFilesDistrict(id: string | number): AxiosPromise {
    return EndPointService.get(`/district_docs`, {
        params: {
            'district.id': id,
        },
    });
}

function updateDistrict(id: number | string, payload: any): AxiosPromise {
    return EndPointService.put(`/districts/${id}`, { ...payload });
}

export default {
    getDistricts,
    getDistrictsSmall,
    getFilesDistrict,
    createFilesDistrict,
    deleteFileDistrict,
    getDistrict,
    deleteDistrict,
    createDistrict,
    updateDistrict,
};
